// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ITableHeadersProps } from './types';
import { TABLE_STYLES, HEADER_CELL_STYLES } from '../../consts/styles';
import Heading from '../../../../../generic-components/Heading';

export const TableHeader = ({ columns }: ITableHeadersProps) => {
  const { t } = useTranslation();
  const headerCells = columns.map((column) => (
    <th
      id={`th_${column.key}`}
      key={column.key}
      className={TABLE_STYLES.TableTH}
    >
      <div className={HEADER_CELL_STYLES[column.key]}>
        <Heading title={t(column.title)} className='' />
      </div>
    </th>
  ));
  return (
    <thead className={TABLE_STYLES.TableTHead}>
      <tr>
        {headerCells}
      </tr>
    </thead>
  );
};
